<script>
  import { onMount } from "svelte";
  import { Card } from "../../components/ui";
  import { currentProduct } from "../../stores/product.js";
  import { getBuyerPersonas } from "../../helper/GetHelper";
  import { navigateTo } from "svelte-router-spa";

  export let currentRoute;
  let model = [];

  const productId = currentRoute.namedParams.id; //productId

  onMount(() => {
    getBuyerPersonas(productId).then(data => {
      model = data;
    });
  });
</script>

<div>
  {#each model as buyerPersona}
    <div
      on:click={() => {
        console.log(`/product/${productId}/buyer-personas/${buyerPersona.id}`);
        navigateTo(`/product/${productId}/buyer-personas/persona/${buyerPersona.id}`);
      }}>
      <Card>Persona: {buyerPersona.data.roles}</Card>
    </div>
  {/each}
</div>
<!-- <div>Buyer Persona Overview</div>
<div class="my-6 p-4">
  <h2 class="text-2xl">Pains</h2>
  <ul>
    {#each model.pjg.pains.items as pain}
      <li>{pain.text}</li>
    {/each}
  </ul>
</div>

<div class="my-6 p-4">
  <h2 class="text-2xl">Gains</h2>
  <ul>
    {#each model.pjg.gains.items as gain}
      <li>{gain.text}</li>
    {/each}
  </ul>
</div> -->

<!-- <div class="my-6 p-4">
  <h2 class="text-2xl">Jobs</h2>
  <ul>
    {#each model.pjg.jobs.items as job}
      <li>{job.text}</li>
    {/each}
  </ul>
</div> -->
